// Define an interface for the `variants` array item
import {ProductTypes, ProductVariantStatus} from "../../ecommerce-product.enum";
import {IMedia} from "../../ecommerce-product.interface";

interface Variant {
  option: string;
  option_value: string;
}

// Define the main interface for the form data
export interface IAddProductForm {
  type: ProductTypes;
  description_group: {
    status: string;
    name: string;
    short_description: string;
    long_description: string;
  };
  media_group: {
    images: {
      id: number;
      imageUrl?: string;
      file?: File;
      base64?: string;
      order?: number;
    }[]
  };
  pricing_group: {
    price: string;
    sale_price: string;
    charge_tax: boolean;
    tax_percent: string;
  };
  variants_group: {
    variants: Variant[];
  };
  inventory_group: {
    stock_status: string;
    track_quantity: boolean;
    backorder_status: string;
    quantity: string;
  };
  linked_products_group: {
    upsells: { name: string; id: number }[];
    cross_sells: { name: string; id: number }[];
  };
  shipping_group: {
    weight: string;
    weight_type: string;
    shipping_class_id: number;
    shipping_class: string;
    length: string;
    width: string;
    height: string;
  };
  category_group: {
    category: {
      label: string;
      id: number;
    };
    subcategory: {
      label: string;
      id: number;
    };
    template: {
      label: string;
      id: number;
    };
    collection:
      {
        label: string;
        id: number;
      }[];
  };
  tax_class: {
    slug: string;
    name: string;
  };
}

export enum TaxStatus {
  TAXABLE = 'taxable',
  SHIPPING = 'shipping',
  NONE = 'none'
}


export interface IOption {
  option: {
    value?: number;
    label: string;
    line_id?: number;
  };
  option_value: {
    name: string;
    id?: string;
    line_id?: number;
  }[];
}

export interface ICategory {
  id: number;
  name: string;
  slug?: string;
  parent?: number;
  description?: string;
  display?: string;
  image?: any;
  menu_order?: number;
  count?: number;
  _links?: any;
}

export interface IAttributeTerm {
  id: number;
  name: string;
  slug: string;
  description: string;
  menu_order: number;
  count: number;
  _links: any;
}

export interface IAttribute {
  id: number;
  name: string;
  slug: string;
  type: string;
  order_by: string;
  has_archives: boolean;
  terms: IAttributeTerm[];
  _links: any;
}

export interface ITemplate {
  id: number;
  title: string;
}

export interface ITaxClass {
  slug: string;
  name: string;
}

export interface IShippingClass {
  count: number;
  description: string;
  id: number;
  name: string;
  slug: string;
}

export interface ITag {
  id: number;
  name: string;
  slug: string;
  description: string;
  count: number;
  _links: any;
}

export interface IVariantsUpload {
  id: number;
  price: string;
  sale_price: string;
  regular_price: string;
  sku: string;
  on_sale: boolean;
  manage_stock: boolean;
  status: ProductVariantStatus;
  stock_quantity: number;
  backorders: string;
  stock_status: string;
  image: IMedia;
  dimensions: {
    length: string;
    width: string;
    height: string;
  };
  weight: string;
  attributes: Array<{
    id: number;
    option: string;
  }>;
}

export interface IVariantsForm {
  id: number;
  checked: boolean;
  options: IVariantsFormAttributeTerm[];
  price: string;
  sale_price: string;
  available: number;
  stock_quantity: number;
  backorder_status: string;
  stock_status: string;
  length: string;
  width: string;
  height: string;
  image: IMedia;
  sku: string;
  weight: string;
  status: ProductVariantStatus;
}

export interface IVariantsFormAttributeTerm {
  name: string;
  line_id: number;
}

export interface IVariation {
  id: number;
  date_created: string;
  date_created_gmt: string;
  date_modified: string;
  date_modified_gmt: string;
  description: string;
  permalink: string;
  sku: string;
  price: string;
  regular_price: string;
  sale_price: string;
  date_on_sale_from: any;
  date_on_sale_from_gmt: any;
  date_on_sale_to: any;
  date_on_sale_to_gmt: any;
  on_sale: boolean;
  status: ProductVariantStatus;
  purchasable: boolean;
  virtual: boolean;
  downloadable: boolean;
  downloads: Array<any>;
  download_limit: number;
  download_expiry: number;
  tax_status: string;
  tax_class: string;
  manage_stock: boolean;
  stock_quantity: any;
  stock_status: string;
  backorders: string;
  backorder_status: string;
  backorders_allowed: boolean;
  backordered: boolean;
  low_stock_amount: any;
  weight: string;
  dimensions: {
    length: string;
    width: string;
    height: string;
  };
  shipping_class: string;
  shipping_class_id: number;
  image: any;
  attributes: Array<{
    id: number;
    name: string;
    option: string;
  }>;
  menu_order: number;
  meta_data: Array<any>;
  _links: {
    self: Array<{
      href: string;
    }>
    collection: Array<{
      href: string;
    }>
    up: Array<{
      href: string;
    }>
  };
}
